<div class="main-content">
  <div class="container-fluid mt-4">
    <!-- Header Section -->
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="mb-2">Reports</h1>
        <p class="text-muted mb-4">Analytics reports</p>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row g-3">
              <!-- From Date -->
              <div class="col-md-3">
                <label for="dpFrom" class="form-label">From Date</label>
                <div class="input-group btn-group">
                  <input
                    class="form-control"
                    placeholder="Beginning of recording"
                    id="dpFrom"
                    name="dpFrom"
                    ngbDatepicker
                    #dpFrom="ngbDatepicker"
                    (click)="dpFrom.toggle()"
                    [(ngModel)]="fromDate"
                  />
                  <div class="input-group-append">
                    <button class="btn" (click)="dpFrom.toggle()" type="button">
                      <fa-icon icon="calendar"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- To Date -->
              <div class="col-md-3">
                <label for="dpTo" class="form-label">To Date</label>
                <div class="input-group btn-group">
                  <input
                    class="form-control"
                    placeholder="Today"
                    id="dpTo"
                    name="dpTo"
                    ngbDatepicker
                    #dpTo="ngbDatepicker"
                    (click)="dpTo.toggle()"
                    [(ngModel)]="toDate"
                  />
                  <div class="input-group-append">
                    <button class="btn" (click)="dpTo.toggle()" type="button">
                      <fa-icon icon="calendar"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Role Dropdown -->
              <div class="col-md-3">
                <label for="roleSelect" class="form-label">Role</label>
                <select class="form-select" id="roleSelect" [(ngModel)]="selectedRole">
                  <option *ngFor="let role of roles" [value]="role.name">{{ role.name }}</option>
                </select>
              </div>

              <!-- Filter Button -->
              <div class="col-md-3">
                <label class="form-label">&nbsp;</label>
                <div class="btn-group" role="group">
                  <button class="btn btn-primary w-100" (click)="applyFilters()">
                    <fa-icon icon="filter" class="me-2"></fa-icon>
                    Apply Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Results Section -->
  <div class="row" *ngIf="reportData.length > 0 || isLoading || hasNoResultsAfterFiltering">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title mb-4">Report Results</h2>

          <!-- Loading State -->
          <div *ngIf="isLoading" class="text-center py-4">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading report data...</p>
          </div>

          <!-- Search Field -->
          <div *ngIf="!isLoading && reportData.length > 0" class="mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Search by path or date..."
              [(ngModel)]="searchQuery"
              (ngModelChange)="filterReportData()"
            />
          </div>

          <!-- Table View -->
          <div *ngIf="!isLoading && reportData.length > 0" class="table-responsive">
            <div *ngIf="filteredReportData.length > 0">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th>Path</th>
                    <th>Time</th>
                    <th>Records</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let entry of filteredReportData">
                    <td class="path-column">
                      <a [href]="entry.nodeLink" target="_blank" rel="noopener noreferrer"> {{ entry.displayPath }} </a>
                    </td>
                    <td>{{ formatTime(entry.totalTime) }}</td>
                    <td>
                      <span class="record-count"
                        >{{ entry.recordCount }} record<ng-container *ngIf="entry.recordCount !== 1">s</ng-container></span
                      >
                    </td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-icon" title="View chart details" (click)="openChartModal(entry)">
                        <fa-icon icon="chart-bar"></fa-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="filteredReportData.length === 0" class="text-center py-4">
              <p class="text-muted">No results match your search.</p>
            </div>
          </div>

          <!-- Empty State - No results after filtering -->
          <div *ngIf="!isLoading && hasNoResultsAfterFiltering" class="text-center py-4">
            <p class="text-muted">No results match your search.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart Details Modal -->
  <div class="modal-overlay" *ngIf="showChartModal" (click)="closeChartModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">{{ selectedEntry?.displayPath }}</h2>
        <button class="btn-close" (click)="closeChartModal()">
          <fa-icon icon="times"></fa-icon>
        </button>
      </div>

      <div class="modal-body">
        <div class="modal-container">
          <!-- Left Side - Records List -->
          <div class="records-list">
            <h3>All Records</h3>
            <div class="records-scroll">
              <div class="record-item" *ngFor="let record of selectedEntry?.records">
                <div class="record-time">{{ formatTime(record.time) }}</div>
                <div class="record-date">{{ record.dateTime }}</div>
              </div>
            </div>
          </div>

          <!-- Right Side - Chart -->
          <div class="chart-section">
            <div class="chart-header">
              <h3>Time per Hour</h3>
              <div class="day-navigator" *ngIf="daysWithData.length > 0">
                <button class="btn btn-sm btn-nav" (click)="previousDay()" [disabled]="currentDayIndex === 0" title="Previous day">
                  <fa-icon icon="chevron-left"></fa-icon>
                </button>
                <span class="day-label">{{ currentDay?.date }}</span>
                <button
                  class="btn btn-sm btn-nav"
                  (click)="nextDay()"
                  [disabled]="currentDayIndex === daysWithData.length - 1"
                  title="Next day"
                >
                  <fa-icon icon="chevron-right"></fa-icon>
                </button>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas
                baseChart
                width="400"
                height="250"
                [datasets]="chartDatasets"
                [labels]="chartLabels"
                [options]="chartOptions"
                [colors]="chartColors"
                [chartType]="'line'"
                [legend]="false"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
